import { default as indexyUNWfSFNezMeta } from "/app/pages/_index/[lang]/index.vue?macro=true";
import { default as indexGXgOAj2CxAMeta } from "/app/pages/about/[[lang]]/index.vue?macro=true";
import { default as indexJ4eV4VsqRAMeta } from "/app/pages/academy/articles/[[lang]]/index.vue?macro=true";
import { default as indexKMBMJJaJqYMeta } from "/app/pages/academy/detail/[[lang]]/index.vue?macro=true";
import { default as indexQxzZHAJNHUMeta } from "/app/pages/academy/index/[[lang]]/index.vue?macro=true";
import { default as indexHPauHdqIibMeta } from "/app/pages/BMXstaketolist/[[lang]]/index.vue?macro=true";
import { default as indexgGqE8wZv8RMeta } from "/app/pages/BMXstaketolist/stakelist/[[lang]]/index.vue?macro=true";
import { default as indexD52vq8dS11Meta } from "/app/pages/demo/[[lang]]/index.vue?macro=true";
import { default as index1mKJ26iQqLMeta } from "/app/pages/login/[lang]/index.vue?macro=true";
import { default as indexPI3YVMJL5NMeta } from "/app/pages/messages/[[lang]]/index.vue?macro=true";
import { default as carnival0HiZ8GUOmMMeta } from "/app/pages/nft/[[lang]]/carnival.vue?macro=true";
import { default as collectible6vtoKuUQYJMeta } from "/app/pages/nft/[[lang]]/collectible.vue?macro=true";
import { default as creatorAXpOFa96DqMeta } from "/app/pages/nft/[[lang]]/creator.vue?macro=true";
import { default as goods_45detailF7RygtitdUMeta } from "/app/pages/nft/[[lang]]/goods-detail.vue?macro=true";
import { default as homeNfNSaxEHQ3Meta } from "/app/pages/nft/[[lang]]/home.vue?macro=true";
import { default as marketplace5CzB2pUnqPMeta } from "/app/pages/nft/[[lang]]/marketplace.vue?macro=true";
import { default as saleCiYMthOC8LMeta } from "/app/pages/nft/[[lang]]/sale.vue?macro=true";
import { default as usercenter9DoCOeIZpYMeta } from "/app/pages/nft/[[lang]]/usercenter.vue?macro=true";
import { default as index79LeQPENttMeta } from "/app/pages/p2p/ad-detail/[[lang]]/index.vue?macro=true";
import { default as indexUzPOb34513Meta } from "/app/pages/p2p/ad-orders/[[lang]]/index.vue?macro=true";
import { default as indexaJuz2cpxRwMeta } from "/app/pages/p2p/ads-manage/[[lang]]/index.vue?macro=true";
import { default as indexsxq1rrTatlMeta } from "/app/pages/p2p/ads-merchant/[[lang]]/index.vue?macro=true";
import { default as indexYK3iPb519rMeta } from "/app/pages/p2p/create-ad/[[lang]]/index.vue?macro=true";
import { default as storeiLPGjD6HDDMeta } from "/app/pages/p2p/create-ad/[[lang]]/store.ts?macro=true";
import { default as indexVptb3fEoEYMeta } from "/app/pages/p2p/index/[[lang]]/index.vue?macro=true";
import { default as indexOg55AYXAZ4Meta } from "/app/pages/p2p/merchant/apply/[[lang]]/index.vue?macro=true";
import { default as indexvHjYYdX4UHMeta } from "/app/pages/p2p/merchant/apply/form/[lang]/index.vue?macro=true";
import { default as indexGtlzlG76YbMeta } from "/app/pages/p2p/myprofile/[[lang]]/index.vue?macro=true";
import { default as indexX7GZT41envMeta } from "/app/pages/p2p/trading-detail/[[lang]]/index.vue?macro=true";
import { default as childEWtRqd76ylMeta } from "/app/pages/parent/child.vue?macro=true";
import { default as indexpN7RlG11XfMeta } from "/app/pages/partner/[[lang]]/index.vue?macro=true";
import { default as indexDt1nJjJPjvMeta } from "/app/pages/teams-trading/[[lang]]/index.vue?macro=true";
import { default as indexiWc1pLBOFZMeta } from "/app/pages/test/[lang]/index.vue?macro=true";
import { default as indexNvWVCnUJ0xMeta } from "/app/pages/vip-earn/[[lang]]/index.vue?macro=true";
import { default as config9LeUahypOoMeta } from "/app/pages/vip-portal/[[lang]]/config.ts?macro=true";
import { default as index9vxCBfzL67Meta } from "/app/pages/vip-portal/[[lang]]/index.vue?macro=true";
import { default as index4APzN6BqJIMeta } from "/app/pages/vip/[[lang]]/index.vue?macro=true";
export default [
  {
    name: "_index-lang",
    path: "/_index/:lang()",
    component: () => import("/app/pages/_index/[lang]/index.vue").then(m => m.default || m)
  },
  {
    name: "about-lang",
    path: "/about/:lang?",
    component: () => import("/app/pages/about/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "academy-articles-lang",
    path: "/academy/articles/:lang?",
    component: () => import("/app/pages/academy/articles/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "academy-detail-lang",
    path: "/academy/detail/:lang?",
    component: () => import("/app/pages/academy/detail/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "academy-index-lang",
    path: "/academy/:lang?",
    component: () => import("/app/pages/academy/index/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "BMXstaketolist-lang",
    path: "/BMXstaketolist/:lang?",
    component: () => import("/app/pages/BMXstaketolist/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "BMXstaketolist/stakelist",
    path: "/BMXstaketolist/stakelist/:lang?",
    meta: indexgGqE8wZv8RMeta || {},
    component: () => import("/app/pages/BMXstaketolist/stakelist/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "demo-lang",
    path: "/demo/:lang?",
    component: () => import("/app/pages/demo/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "login-lang",
    path: "/login/:lang()",
    component: () => import("/app/pages/login/[lang]/index.vue").then(m => m.default || m)
  },
  {
    name: "messages",
    path: "/messages/:lang?",
    meta: indexPI3YVMJL5NMeta || {},
    component: () => import("/app/pages/messages/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "nft-lang-carnival",
    path: "/nft/:lang?/carnival",
    component: () => import("/app/pages/nft/[[lang]]/carnival.vue").then(m => m.default || m)
  },
  {
    name: "nft-lang-collectible",
    path: "/nft/:lang?/collectible",
    component: () => import("/app/pages/nft/[[lang]]/collectible.vue").then(m => m.default || m)
  },
  {
    name: "nft-lang-creator",
    path: "/nft/:lang?/creator",
    component: () => import("/app/pages/nft/[[lang]]/creator.vue").then(m => m.default || m)
  },
  {
    name: "nft-lang-goods-detail",
    path: "/nft/:lang?/goods-detail",
    component: () => import("/app/pages/nft/[[lang]]/goods-detail.vue").then(m => m.default || m)
  },
  {
    name: "nft-lang-home",
    path: "/nft/:lang?/home",
    component: () => import("/app/pages/nft/[[lang]]/home.vue").then(m => m.default || m)
  },
  {
    name: "nft-lang-marketplace",
    path: "/nft/:lang?/marketplace",
    component: () => import("/app/pages/nft/[[lang]]/marketplace.vue").then(m => m.default || m)
  },
  {
    name: "nft-lang-sale",
    path: "/nft/:lang?/sale",
    component: () => import("/app/pages/nft/[[lang]]/sale.vue").then(m => m.default || m)
  },
  {
    name: "nft-lang-usercenter",
    path: "/nft/:lang?/usercenter",
    component: () => import("/app/pages/nft/[[lang]]/usercenter.vue").then(m => m.default || m)
  },
  {
    name: "p2p/ad-detail",
    path: "/p2p/ad-detail/:lang?",
    meta: index79LeQPENttMeta || {},
    component: () => import("/app/pages/p2p/ad-detail/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "p2p/ad-orders",
    path: "/p2p/ad-orders/:lang?",
    meta: indexUzPOb34513Meta || {},
    component: () => import("/app/pages/p2p/ad-orders/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "p2p/ads-manage",
    path: "/p2p/ads-manage/:lang?",
    meta: indexaJuz2cpxRwMeta || {},
    component: () => import("/app/pages/p2p/ads-manage/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "p2p/ads-merchant",
    path: "/p2p/ads-merchant/:lang?",
    meta: indexsxq1rrTatlMeta || {},
    component: () => import("/app/pages/p2p/ads-merchant/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "p2p/create-ad",
    path: "/p2p/create-ad/:lang?",
    meta: indexYK3iPb519rMeta || {},
    component: () => import("/app/pages/p2p/create-ad/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "p2p-create-ad-lang-store",
    path: "/p2p/create-ad/:lang?/store",
    component: () => import("/app/pages/p2p/create-ad/[[lang]]/store.ts").then(m => m.default || m)
  },
  {
    name: "p2p",
    path: "/p2p/:lang?",
    meta: indexVptb3fEoEYMeta || {},
    component: () => import("/app/pages/p2p/index/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "p2p/merchant-apply",
    path: "/p2p/merchant/apply/:lang?",
    meta: indexOg55AYXAZ4Meta || {},
    component: () => import("/app/pages/p2p/merchant/apply/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "p2p/merchant-apply-form",
    path: "/p2p/merchant/apply/form/:lang()",
    meta: indexvHjYYdX4UHMeta || {},
    component: () => import("/app/pages/p2p/merchant/apply/form/[lang]/index.vue").then(m => m.default || m)
  },
  {
    name: "p2p/myprofile",
    path: "/p2p/myprofile/:lang?",
    meta: indexGtlzlG76YbMeta || {},
    component: () => import("/app/pages/p2p/myprofile/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "p2p/trading-detail",
    path: "/p2p/trading-detail/:lang?",
    meta: indexX7GZT41envMeta || {},
    component: () => import("/app/pages/p2p/trading-detail/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "parent-child",
    path: "/parent/child",
    component: () => import("/app/pages/parent/child.vue").then(m => m.default || m)
  },
  {
    name: "partner-lang",
    path: "/partner/:lang?",
    component: () => import("/app/pages/partner/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "BWTC-lang",
    path: "/BWTC/:lang?",
    meta: indexDt1nJjJPjvMeta || {},
    component: () => import("/app/pages/teams-trading/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "test-lang",
    path: "/test/:lang()",
    component: () => import("/app/pages/test/[lang]/index.vue").then(m => m.default || m)
  },
  {
    name: "vip-earn-lang",
    path: "/vip-earn/:lang?",
    meta: indexNvWVCnUJ0xMeta || {},
    component: () => import("/app/pages/vip-earn/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "vip-portal-lang-config",
    path: "/vip-portal/:lang?/config",
    component: () => import("/app/pages/vip-portal/[[lang]]/config.ts").then(m => m.default || m)
  },
  {
    name: "vip-portal-lang",
    path: "/vip-portal/:lang?",
    component: () => import("/app/pages/vip-portal/[[lang]]/index.vue").then(m => m.default || m)
  },
  {
    name: "vip-lang",
    path: "/vip/:lang?",
    component: () => import("/app/pages/vip/[[lang]]/index.vue").then(m => m.default || m)
  }
]